export default __webpack_public_path__ + "static/media/ImageSix.f82f8511.jpg";